var _path, _path2, _path3, _path4, _ellipse, _path5, _path6, _g, _path7, _path8, _path9, _path10, _g2, _g3, _g4, _g5, _g6, _rect, _g7, _rect2, _g8, _path11, _path12, _path13, _path14, _rect3, _circle, _path15, _path16, _path17, _path18, _circle2, _circle3, _circle4, _circle5, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _circle6, _circle7, _circle8, _circle9, _path26, _path27, _path28, _path29, _circle10, _path30, _circle11, _path31, _circle12, _path32, _circle13, _path33, _circle14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeaturesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 196,
    viewBox: "0 0 240 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.062 138.178L160.4 127.223L145.741 149.038C154.305 156.185 168.692 161.382 176.127 159.795C191.384 156.538 222.215 113.219 226.493 109.921C241.057 98.6931 245.791 94.4323 227.568 103.156C210.193 111.474 219.395 103.156 215.139 103.156C210.025 103.514 211.719 108.052 213.618 111.305L179.062 138.178Z",
    fill: "url(#paint0_linear_740_676)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1724 121.582C78.4376 117.925 99.2425 111.339 108.379 108.503L118.046 109.558C124.137 111.068 137.201 113.642 143.211 116.079C149.22 118.515 160.126 126.284 170.3 132.763L167.898 141.083C165.74 148.554 160.035 154.48 152.65 156.919C150.75 169.004 149.111 188.65 149.382 194.741L78.6797 194.686L75.4427 164.783L60.8834 166.342L48.5851 156.919C63.9845 130.283 66.5908 126.152 73.1724 121.582Z",
    fill: "url(#paint1_linear_740_676)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9456 190.296C30.5441 187.455 45.1139 164.751 49.0856 157.253C53.8895 161.297 59.8217 163.764 66.0764 164.32L73.7961 165.006L70.635 172.298L104.763 180.288L109.551 193.57C106.141 192.99 80.803 193.828 52.9456 190.296Z",
    fill: "url(#paint2_linear_740_676)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.762 48.8945C111.864 46.9008 115.026 44.1094 118.854 48.8945H110.762Z",
    fill: "#30235B"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 112.6,
    cy: 117.199,
    rx: 12.2025,
    ry: 8.69561,
    fill: "#CF0606"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.601 116.732L104.307 99.748H120.913L122.821 116.732C122.154 118.732 119.006 122.789 113.177 122.789C105.748 122.789 103.078 118.732 102.601 116.732Z",
    fill: "url(#paint3_linear_740_676)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_740_676",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: 99,
    width: 21,
    height: 24
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.601 116.732L104.307 99.748H120.913L122.824 116.766C122.157 118.766 118.999 122.79 113.17 122.79C105.741 122.79 103.078 118.732 102.601 116.732Z",
    fill: "url(#paint4_linear_740_676)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_740_676)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M126.897 100.398C111.882 118.976 103.492 104.039 99.1574 101.798L102.136 89.2382L119.915 87.1154L126.897 100.398Z",
    fill: "black"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.312 106.566C94.4031 106.566 91.3235 80.8597 96.8567 69.1017C109.306 53.8853 124.869 62.7615 131.093 69.1017C132.592 78.9001 134.245 106.566 112.312 106.566Z",
    fill: "url(#paint5_linear_740_676)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M131.4 86.9002L127.891 84.3154L128.434 82.3912L132.441 85.0337L131.4 86.9002Z",
    fill: "#111111"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8446 86.1507L98.353 83.5658L97.8103 81.6417L93.803 84.2842L94.8446 86.1507Z",
    fill: "#111111"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0554 70.6467C110.752 78.9186 124.827 74.0933 130.278 70.6467C129.13 74.2662 130.756 81.2237 131.712 84.2499C139.973 73.4916 137.273 67.6822 134.89 66.1222C134.492 60.7603 129.618 47.3542 113.254 47.9897C96.8907 48.6252 93.7155 60.2308 94.1789 64.5335C87.983 72.9537 91.6694 81.1862 94.6576 84.2499C98.0554 77.6535 97.9779 73.026 98.0554 70.6467Z",
    fill: "#30235B"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_740_676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.555 56.2683C95.601 55.6338 91.3791 68.0989 90.8125 75.3373C90.7672 75.9168 90.293 76.3733 89.7117 76.3733C89.0914 76.3733 88.5972 75.8561 88.6522 75.2382C89.4793 65.9573 94.4276 49.7394 114.555 50.8577C134.878 51.9867 138.854 68.1653 138.23 77.1839C138.197 77.6665 137.789 78.0313 137.305 78.0313C136.778 78.0313 136.354 77.6032 136.333 77.076C136.034 69.5931 131.06 56.7466 114.555 56.2683Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_740_676)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 138.609,
    y: 80.9911,
    width: 2.57263,
    height: 9.87247,
    rx: 1.28631,
    transform: "rotate(10.0542 138.609 80.9911)",
    fill: "#24C28A"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_740_676)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.082,
    y: 74.5907,
    width: 7.92444,
    height: 20.5658,
    rx: 3.96222,
    transform: "rotate(10.0542 133.082 74.5907)",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_740_676)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.57263,
    height: 9.87247,
    rx: 1.28631,
    transform: "matrix(-0.984643 0.17458 0.17458 0.984643 87.4404 80.9911)",
    fill: "#24C28A"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_740_676)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.92444,
    height: 20.5658,
    rx: 3.96222,
    transform: "matrix(-0.984643 0.17458 0.17458 0.984643 92.8953 74.5907)",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_740_676",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 75,
    width: 11,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7.92444,
    height: 20.5658,
    rx: 3.96222,
    transform: "matrix(-0.984643 0.17458 0.17458 0.984643 92.8954 74.5907)",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_740_676)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.1638,
    y: 74.5907,
    width: 10.3079,
    height: 22.3246,
    transform: "rotate(-10.0977 89.1638 74.5907)",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_740_676",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 130,
    y: 75,
    width: 11,
    height: 21
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 133.083,
    y: 74.5907,
    width: 7.92444,
    height: 20.5658,
    rx: 3.96222,
    transform: "rotate(10.0542 133.083 74.5907)",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_740_676)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.3079,
    height: 22.3246,
    transform: "matrix(-0.98451 -0.175326 -0.175326 0.98451 137.295 74.5907)",
    fill: "#E8E8E8"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M104.595 89.9028C102.061 89.9028 100.785 87.9062 100.461 87.0146C100.088 86.2689 99.7938 84.3262 100.677 82.7831C101.799 80.821 107.075 80.2738 108.923 83.0458C110.771 85.8178 108.923 89.9028 104.595 89.9028Z",
    fill: "#E6FCFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M121.382 89.9028C123.916 89.9028 125.192 87.9062 125.516 87.0146C125.889 86.2689 126.183 84.3262 125.301 82.7831C124.178 80.821 118.902 80.2738 117.054 83.0458C115.206 85.8178 117.054 89.9028 121.382 89.9028Z",
    fill: "#E6FCFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.232 82.4351C106.1 78.8065 102.368 80.3418 100.156 81.2515L100.156 81.2515C99.9102 81.3527 99.6831 81.4461 99.4763 81.5239L98.0916 81.5264C97.8309 81.5269 97.6204 81.7397 97.6227 82.0004L97.633 83.1645C97.6353 83.4223 97.845 83.6301 98.1028 83.6301L99.104 83.6301C98.3789 89.8557 102.97 91.5218 106.642 90.3996C109.915 89.3991 110.792 86.5684 110.967 84.7925C111.667 83.2409 114.737 83.9577 114.858 84.758L114.868 84.8209C115.012 85.7953 115.738 90.7041 121.264 90.711C125.791 90.7167 127.019 86.6726 127.067 84.6498L128.239 84.6394C128.498 84.6371 128.707 84.4249 128.704 84.1654L128.692 82.7413C128.69 82.4819 128.477 82.2734 128.218 82.2757L127.046 82.2861C124.097 79.2988 117.763 79.5786 115.532 82.3881C113.071 81.8205 110.973 82.1829 110.232 82.4351ZM104.595 89.9028C102.061 89.9028 100.785 87.9062 100.461 87.0146C100.088 86.2689 99.794 84.3262 100.677 82.7831C101.799 80.821 107.075 80.2738 108.923 83.0458C110.771 85.8178 108.923 89.9028 104.595 89.9028ZM125.516 87.0146C125.192 87.9061 123.916 89.9028 121.383 89.9028C117.054 89.9028 115.206 85.8178 117.054 83.0458C118.902 80.2738 124.178 80.821 125.301 82.7831C126.183 84.3262 125.889 86.2689 125.516 87.0146Z",
    fill: "#111111"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1818 192.221C77.1818 191.961 77.3931 191.749 77.6538 191.749H150.191C150.647 191.749 151.017 192.119 151.017 192.575V192.575C151.017 193.944 149.908 195.053 148.539 195.053H80.0137C78.4497 195.053 77.1818 193.785 77.1818 192.221V192.221Z",
    fill: "#B4B4B4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 77.182,
    y: 143.576,
    width: 73.8352,
    height: 49.4006,
    rx: 1.38442,
    fill: "url(#paint6_linear_740_676)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 114.099,
    cy: 168.276,
    r: 5.25099,
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6361 80.0216C61.7298 78.42 62.0491 77.0794 62.3152 76.3342C62.838 77.6412 63.0964 78.8961 63.1838 80.0404C64.3281 80.1278 65.5829 80.3862 66.8898 80.909C66.1447 81.1751 64.8041 81.4944 63.2026 81.588C63.1133 83.2882 62.6761 84.6092 62.3152 85.2858C61.8761 84.0564 61.6757 82.7918 61.6235 81.6007C60.4324 81.5485 59.1677 81.3481 57.9382 80.909C58.6148 80.5481 59.9359 80.1109 61.6361 80.0216Z",
    fill: "url(#paint7_linear_740_676)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0039 69.4849C49.0663 68.4189 49.2788 67.5265 49.4559 67.0305C49.8039 67.9005 49.9759 68.7357 50.0341 69.4974C50.7958 69.5556 51.631 69.7276 52.501 70.0756C52.005 70.2527 51.1126 70.4652 50.0466 70.5276C49.9872 71.6593 49.6961 72.5386 49.4559 72.989C49.1637 72.1706 49.0303 71.3288 48.9955 70.536C48.2027 70.5012 47.3609 70.3679 46.5425 70.0756C46.9929 69.8354 47.8722 69.5443 49.0039 69.4849Z",
    fill: "url(#paint8_linear_740_676)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6495 61.9782C28.7431 60.3767 29.0624 59.036 29.3286 58.2909C29.8514 59.5979 30.1098 60.8527 30.1971 61.997C31.3414 62.0844 32.5962 62.3428 33.9032 62.8656C33.1581 63.1317 31.8175 63.451 30.216 63.5446C30.1267 65.2449 29.6894 66.5659 29.3286 67.2425C28.8895 66.0131 28.6891 64.7484 28.6368 63.5573C27.4457 63.5051 26.1811 63.3047 24.9516 62.8656C25.6282 62.5047 26.9492 62.0675 28.6495 61.9782Z",
    fill: "url(#paint9_linear_740_676)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3915 98.7846C30.5293 96.4284 30.999 94.456 31.3906 93.3597C32.1597 95.2826 32.5399 97.1288 32.6684 98.8123C34.352 98.9408 36.1982 99.321 38.1212 100.09C37.0248 100.482 35.0524 100.952 32.6961 101.089C32.5647 103.591 31.9215 105.534 31.3906 106.53C30.7445 104.721 30.4497 102.86 30.3729 101.108C28.6205 101.031 26.76 100.736 24.9512 100.09C25.9467 99.5593 27.8901 98.916 30.3915 98.7846Z",
    fill: "url(#paint10_linear_740_676)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.7074,
    cy: 84.8522,
    r: 0.865139,
    fill: "#2F235A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.5609,
    cy: 60.0467,
    r: 0.865139,
    fill: "#FE9076"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.0458,
    cy: 81.4175,
    r: 0.865139,
    fill: "#FFA400"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.8189,
    cy: 98.1955,
    r: 0.865139,
    fill: "#23BB86"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4411 56.4359C60.4851 53.7496 54.9754 48.0117 48.584 46.5508",
    stroke: "#FE9076",
    strokeWidth: 0.753022,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3957 79.0987C14.5048 77.4601 7.11697 74.5104 0.692912 75.8199",
    stroke: "#FFA400",
    strokeWidth: 0.753022,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8495 100.708C55.3681 102.016 51.8041 105.728 49.399 110.12",
    stroke: "#23BB86",
    strokeWidth: 0.753022,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.754 80.0215C163.66 78.42 163.341 77.0794 163.075 76.3342C162.552 77.6412 162.293 78.8961 162.206 80.0404C161.062 80.1277 159.807 80.3862 158.5 80.909C159.245 81.1751 160.586 81.4944 162.187 81.588C162.276 83.2882 162.714 84.6092 163.075 85.2858C163.514 84.0564 163.714 82.7918 163.766 81.6007C164.957 81.5484 166.222 81.3481 167.451 80.909C166.775 80.5481 165.454 80.1109 163.754 80.0215Z",
    fill: "url(#paint11_linear_740_676)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.386 69.485C176.324 68.419 176.112 67.5266 175.934 67.0306C175.586 67.9006 175.414 68.7359 175.356 69.4975C174.595 69.5557 173.759 69.7277 172.889 70.0757C173.385 70.2528 174.278 70.4654 175.344 70.5277C175.403 71.6594 175.694 72.5387 175.934 72.9891C176.227 72.1707 176.36 71.329 176.395 70.5361C177.188 70.5014 178.029 70.368 178.848 70.0757C178.397 69.8355 177.518 69.5445 176.386 69.485Z",
    fill: "url(#paint12_linear_740_676)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.74 61.9783C196.647 60.3768 196.327 59.0362 196.061 58.291C195.539 59.598 195.28 60.8528 195.193 61.9971C194.048 62.0845 192.794 62.3429 191.487 62.8657C192.232 63.1318 193.572 63.4511 195.174 63.5447C195.263 65.245 195.7 66.566 196.061 67.2426C196.5 66.0132 196.701 64.7485 196.753 63.5574C197.944 63.5052 199.209 63.3048 200.438 62.8657C199.762 62.5048 198.441 62.0676 196.74 61.9783Z",
    fill: "url(#paint13_linear_740_676)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.998 98.7848C194.861 96.4286 194.391 94.4562 193.999 93.3599C193.23 95.2828 192.85 97.1289 192.721 98.8124C191.038 98.941 189.192 99.3212 187.269 100.09C188.365 100.482 190.337 100.952 192.694 101.089C192.825 103.591 193.468 105.534 193.999 106.53C194.645 104.721 194.94 102.86 195.017 101.108C196.769 101.031 198.63 100.736 200.439 100.09C199.443 99.5594 197.5 98.9162 194.998 98.7848Z",
    fill: "url(#paint14_linear_740_676)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 0.865139,
    transform: "matrix(-1 0 0 1 180.683 84.8522)",
    fill: "#2F235A"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 0.865139,
    transform: "matrix(-1 0 0 1 160.829 60.0467)",
    fill: "#FE9076"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    r: 0.865139,
    transform: "matrix(-1 0 0 1 204.344 81.4175)",
    fill: "#FFA400"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    r: 0.865139,
    transform: "matrix(-1 0 0 1 165.571 98.1955)",
    fill: "#23BB86"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M162.949 56.4359C164.905 53.7496 170.414 48.0117 176.806 46.5508",
    stroke: "#FE9076",
    strokeWidth: 0.753022,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M207.994 79.0988C210.885 77.4602 218.273 74.5105 224.697 75.82",
    stroke: "#FFA400",
    strokeWidth: 0.753022,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M168.54 100.708C170.022 102.016 173.586 105.728 175.991 110.12",
    stroke: "#23BB86",
    strokeWidth: 0.753022,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M126.807 26.6014C125.826 25.0861 123.841 25.9116 123.841 27.5623C123.841 28.8019 126.563 30.7409 126.807 30.993C127.053 30.7409 129.64 28.8019 129.64 27.5623C129.64 25.9241 127.79 25.0861 126.807 26.6014V26.6014Z",
    fill: "#FFBCBC"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.74,
    cy: 28.3986,
    r: 6.48353,
    stroke: "#F7F7F7",
    strokeWidth: 0.305238
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M103.54 17.5653C102.672 16.2241 100.914 16.9547 100.914 18.4157C100.914 19.5128 103.323 21.2289 103.54 21.452C103.758 21.2289 106.047 19.5128 106.047 18.4157C106.047 16.9658 104.41 16.2241 103.54 17.5653V17.5653Z",
    fill: "#FFBCBC"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.481,
    cy: 19.1557,
    r: 5.7382,
    stroke: "#F7F7F7",
    strokeWidth: 0.270149
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M118.895 7.71061C118.301 6.79336 117.099 7.29305 117.099 8.29225C117.099 9.04257 118.747 10.2163 118.895 10.3689C119.044 10.2163 120.61 9.04257 120.61 8.29225C120.61 7.30062 119.49 6.79336 118.895 7.71061V7.71061Z",
    fill: "#FFBCBC"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.855,
    cy: 8.79841,
    r: 3.92454,
    stroke: "#F7F7F7",
    strokeWidth: 0.184763
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7719 2.6064C91.286 1.85586 90.3026 2.26473 90.3026 3.08231C90.3026 3.69625 91.6508 4.65663 91.7719 4.7815C91.8939 4.65663 93.175 3.69625 93.175 3.08231C93.175 2.27093 92.2587 1.85586 91.7719 2.6064V2.6064Z",
    fill: "#FFBCBC"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.7388,
    cy: 3.49651,
    r: 3.2112,
    stroke: "#F7F7F7",
    strokeWidth: 0.15118
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3819 37.7897C88.3211 36.1511 86.174 37.0437 86.174 38.8288C86.174 40.1692 89.1175 42.266 89.3819 42.5386C89.6481 42.266 92.4453 40.1692 92.4453 38.8288C92.4453 37.0573 90.4448 36.1511 89.3819 37.7897V37.7897Z",
    fill: "#FFBCBC"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.3095,
    cy: 39.7331,
    r: 7.01102,
    stroke: "#F7F7F7",
    strokeWidth: 0.330072
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_740_676",
    x: 72.674,
    y: 36.708,
    width: 81.5904,
    height: 59.1767,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.8793
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.98704
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0386285 0 0 0 0 0.0648437 0 0 0 0 0.104167 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_740_676"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_740_676",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_740_676",
    x: 121.116,
    y: 67.1009,
    width: 35.7956,
    height: 41.709,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.8793
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.98704
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0386285 0 0 0 0 0.0648437 0 0 0 0 0.104167 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_740_676"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_740_676",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_740_676",
    x: 114.148,
    y: 61.1262,
    width: 42.0809,
    height: 52.3212,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.8793
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.98704
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0386285 0 0 0 0 0.0648437 0 0 0 0 0.104167 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_740_676"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_740_676",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_740_676",
    x: 69.1377,
    y: 67.1009,
    width: 35.7956,
    height: 41.709,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.8793
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.98704
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0386285 0 0 0 0 0.0648437 0 0 0 0 0.104167 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_740_676"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_740_676",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_740_676",
    x: 69.7486,
    y: 61.1262,
    width: 42.0809,
    height: 52.3212,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.8793
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.98704
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0386285 0 0 0 0 0.0648437 0 0 0 0 0.104167 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_740_676"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_740_676",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_740_676",
    x1: 183.823,
    y1: 74.5931,
    x2: 185.066,
    y2: 157.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_740_676",
    x1: 114.051,
    y1: 94.2726,
    x2: 108.225,
    y2: 210.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_740_676",
    x1: 106.973,
    y1: 135.277,
    x2: 51.2177,
    y2: 161.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677966,
    stopColor: "#FFEFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_740_676",
    x1: 112.138,
    y1: 81.478,
    x2: 113.116,
    y2: 112.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_740_676",
    x1: 112.138,
    y1: 81.478,
    x2: 110.769,
    y2: 117.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_740_676",
    x1: 113.762,
    y1: 64.8498,
    x2: 113.762,
    y2: 102.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_740_676",
    x1: 129.346,
    y1: 106.5,
    x2: 102.046,
    y2: 204.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171777,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_740_676",
    x1: 62.414,
    y1: 77.287,
    x2: 62.414,
    y2: 85.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE89E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_740_676",
    x1: 49.5217,
    y1: 67.6647,
    x2: 49.5217,
    y2: 73.2593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE89E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_740_676",
    x1: 29.4274,
    y1: 59.2437,
    x2: 29.4274,
    y2: 67.6487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE89E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_740_676",
    x1: 31.5362,
    y1: 94.7615,
    x2: 31.5362,
    y2: 107.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE89E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_740_676",
    x1: 162.976,
    y1: 77.287,
    x2: 162.976,
    y2: 85.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE89E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_740_676",
    x1: 175.869,
    y1: 67.6648,
    x2: 175.869,
    y2: 73.2595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE89E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_740_676",
    x1: 195.962,
    y1: 59.2438,
    x2: 195.962,
    y2: 67.6488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE89E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_740_676",
    x1: 193.854,
    y1: 94.7616,
    x2: 193.854,
    y2: 107.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE89E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF1A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesIcon);
export default __webpack_public_path__ + "static/media/Features-icon.788bd41762f7097c520ec8227dfd523c.svg";
export { ForwardRef as ReactComponent };